import React from 'react';
import { Text, TextProps } from '@chakra-ui/react';
import { format } from 'date-fns';
import { dateFormats } from 'app/constants';
import { Notification } from 'types/notification.types';
import { Invite } from 'types/invite.types';

const htmlToPlainText = (html: string) => html?.replace(/<[^>]*>/g, '');

const ParseMessageBody: React.FC<{
  html: string;
  isMobileView: boolean;
  fontSize: TextProps['fontSize'];
}> = ({ html, isMobileView, fontSize }) => (
  <Text
    title={htmlToPlainText(html)}
    dangerouslySetInnerHTML={{
      __html: html,
    }}
    fontSize={fontSize}
    sx={{
      display: '-webkit-box',
      overflow: 'hidden',
      WebkitLineClamp: isMobileView ? '2' : '1',
      WebkitBoxOrient: 'vertical',
      pr: 1,
    }}
  />
);

const ParseDate: React.FC<
  TextProps & { isoDate: string; fontSize: TextProps['fontSize'] }
> = ({ isoDate, fontSize = 'xs', ...rest }) => (
  <Text
    data-testid="notification-item-date"
    fontSize={fontSize}
    lineHeight="small"
    color="textSubdued"
    {...rest}
  >
    {format(new Date(isoDate), dateFormats.LIST_FORMAT)}
  </Text>
);

export const ParseMessage: React.FC<{
  message: Invite | Notification;
  isMobileView: boolean;
  fontSizeMessage?: TextProps['fontSize'];
  fontSizeDate?: TextProps['fontSize'];
}> = ({ message, isMobileView, fontSizeMessage, fontSizeDate }) => (
  <>
    <ParseMessageBody
      html={message?.body}
      isMobileView={isMobileView}
      fontSize={fontSizeMessage}
    />
    <ParseDate isoDate={message.created.iso} mt={1} fontSize={fontSizeDate} />
  </>
);
